import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/BlocksRendererCustom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Form/PopForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/03-HeroA.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/07-HeroB.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/about/components/Carousel/style-2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/about/components/Loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/styles/page.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/styles/02-Client-Oriented.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/styles/04-Tree.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/styles/06-Benefits.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/components/styles/PopForm.module.css");
